import React, { Suspense } from "react";

const TanStackRouterDevtools =
  import.meta.env.MODE === "production"
    ? () => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import("@tanstack/router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        })),
      );

export function RouterDevtools() {
  return (
    <Suspense fallback={<p>Loading Router Dev Tools...</p>}>
      <TanStackRouterDevtools />
    </Suspense>
  );
}
